import React from "react";

function AppCardFooter({ className = "", children, ...rest }) {
  if (!children) {
    return null;
  }

  const classes = ["ds-card__footer", className].filter(Boolean).join(" ");

  return (
    <footer className={classes} {...rest}>
      {children}
    </footer>
  );
}

AppCardFooter.appCardZone = "footer";

export default AppCardFooter;
